
import React from 'react';
import { useNavigate } from 'react-router-dom';
import founderPortrait from '@/assets/founder-portrait.jpg';

const ArbitrationADR = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative py-16 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ 
            backgroundImage: "url('https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1035&q=80')" 
          }}
        />
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">Arbitration & Mediation</h1>
            <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto">
              Expert alternative dispute resolution services for technology, commercial, and intellectual property disputes
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <h2 className="text-3xl font-bold text-primary mb-6">Dispute Resolution Excellence</h2>

          {/* Author Section */}
          <div className="flex items-center gap-4 mb-10 pb-8 border-b border-gray-200">
            <img src={founderPortrait} alt="Omollo Victor" className="author-avatar" />
            <div>
              <h3 className="font-semibold text-primary text-lg">Omollo Victor</h3>
              <p className="text-gray-500 text-sm">LLB Hons | CPM | Trainee Advocate</p>
              <p className="text-gray-400 text-xs mt-1">Founder & CEO, Wakili Assistant</p>
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-primary mb-8">Artificial Intelligence, Intellectual Property, and the Evolution of Dispute Resolution</h2>

          <article className="prose prose-lg max-w-none text-gray-700 space-y-6">
            <p>
              The intersection of artificial intelligence, intellectual property, and alternative dispute resolution (ADR) represents one of the most dynamic frontiers in modern legal practice. As AI technologies proliferate across industries, they generate novel forms of IP disputes that challenge traditional litigation frameworks and demand more agile, specialized resolution mechanisms. The convergence of these three domains is reshaping how businesses, creators, and legal systems approach conflict in the digital age.
            </p>
            <p>
              At the heart of many AI-related disputes lies the question of IP ownership. When an AI system generates a creative worka piece of music, a visual design, a written article, or even a patentable inventionwho holds the intellectual property rights? Traditional IP law assigns ownership to human creators, but AI-generated outputs blur these boundaries. The Copyright Act in most jurisdictions requires a human author, and patent offices worldwide have largely rejected applications naming AI as an inventor. The landmark DABUS case, in which an AI system was listed as the inventor on patent applications filed across multiple jurisdictions, highlighted the inadequacy of existing legal frameworks to accommodate machine-generated innovation.
            </p>
            <p>
              Trade secret disputes are another growing area where AI and IP intersect. AI models are trained on vast datasets, and the proprietary algorithms, training data, and model architectures underlying these systems often constitute valuable trade secrets. When employees move between companies or when collaborative ventures dissolve, disputes over the ownership and misappropriation of AI-related trade secrets are increasingly common. These conflicts are particularly suited to arbitration and mediation, where confidentiality protections can shield sensitive business information from public disclosurea significant advantage over traditional court proceedings.
            </p>
            <p>
              The role of ADR in technology licensing has expanded significantly as AI becomes embedded in commercial products and services. Software licensing agreements, patent cross-licensing deals, and data-sharing arrangements frequently include arbitration clauses that direct disputes to specialized tribunals rather than national courts. This approach offers several advantages: arbitrators with technical expertise can better evaluate complex AI-related claims, proceedings can be conducted more swiftly than traditional litigation, and the parties retain greater control over the process.
            </p>
            <p>
              International arbitration plays a particularly important role in AI and IP disputes, given the inherently global nature of technology development and deployment. An AI system developed in one country, trained on data from another, and deployed across multiple jurisdictions creates complex questions of applicable law and jurisdictional authority. International arbitration institutions such as the ICC, LCIA, and WIPO Arbitration and Mediation Center provide neutral forums that transcend national boundaries, offering parties a more predictable and enforceable resolution process than navigating multiple court systems.
            </p>
            <p>
              Mediation offers distinct advantages in AI and IP disputes where ongoing business relationships are at stake. Technology partnerships, joint ventures in AI development, and collaborative research arrangements often benefit from the preservation of working relationships that mediation can facilitate. Unlike adversarial litigation, mediation allows parties to explore creative solutionssuch as revised licensing terms, shared IP arrangements, or structured technology-sharing agreementsthat courts may not have the flexibility to impose.
            </p>
            <p>
              The emergence of AI-powered dispute resolution tools adds another layer of complexity and opportunity to this field. AI systems are increasingly being used to assist in case analysis, outcome prediction, and even automated negotiation. While these tools can enhance efficiency, they also raise questions about due process, algorithmic bias, and the appropriate role of technology in legal proceedings. The use of AI in arbitration itself must be governed by principles of transparency, fairness, and accountability.
            </p>
            <p>
              As Africa positions itself as a growing hub for technology innovation and AI development, the need for robust, specialized dispute resolution frameworks becomes increasingly urgent. African businesses and creators engaging with AI technologies require access to arbitration and mediation services that understand both the technical complexities of AI systems and the evolving landscape of IP law. Building this capacity is essential to ensuring that African innovators can protect their rights, resolve disputes efficiently, and participate fully in the global AI economy.
            </p>
          </article>

          {/* Quote Section */}
          <div className="relative my-16">
            <div 
              className="h-96 bg-cover bg-center rounded-lg relative overflow-hidden"
              style={{ 
                backgroundImage: "url('https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80')"
              }}
            >
              <div className="absolute inset-0 bg-black/40" />
              <div className="absolute inset-0 flex items-center justify-center">
                <blockquote className="text-white text-center max-w-4xl px-8">
                  <p className="text-2xl md:text-3xl italic font-light leading-relaxed font-bold text-shadow-lg">
                    "Justice delayed is justice denied. Swift and informed dispute resolution 
                    becomes the cornerstone of fair commercial relationships."
                  </p>
                  <footer className="mt-6 text-gray-200">
                    <cite> Modern Arbitration Principles</cite>
                  </footer>
                </blockquote>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default ArbitrationADR;
